import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { Configuration } from '../../../core/configuration/configuration';
import { SessionHelper } from '../../../core/helper/sessionHelper';
import { A3LCompany } from '../../../core/models/a3LCompany.model';
import { PeriodosVacacionesModel } from '../../../core/models/periodosVacaciones.model';
import { Vacaciones } from '../../../core/models/vacaciones.model';
import { A3LCompanyService } from '../../../core/services/a3LCompany.service';
import { VacacionesService } from '../../../core/services/vacaciones.service';
import { ETipoDia } from '../../../core/Enums/eTipoDia.enum';
import { Utilidades } from '../../../core/helper/utilidades';


@Component({
  selector: 'app-periodos-vacaciones-list',
  templateUrl: './periodos-vacaciones-list.component.html',
  styleUrls: ['./periodos-vacaciones-list.component.scss'],
  providers: [A3LCompanyService, VacacionesService]
})
export class PeriodosVacacionesListComponent implements OnInit, AfterViewInit {

  @ViewChild('gridPeriodos', { static: false }) dataGrid: DxDataGridComponent;

  panelIcon = 'insert_invitation'; // material icon
  panelTitle = 'Vacaciones';
  panelDescription = '';

  holidays: Vacaciones[] = new Array<Vacaciones>();
  periodos: PeriodosVacacionesModel[] = new Array<PeriodosVacacionesModel>();
  companies: A3LCompany[] = new Array<A3LCompany>();
  selectedCompany: number;
  selectedYear: number;

  tiposDia = Utilidades.enumToArray(ETipoDia);

  constructor(
    private _vacacionesService: VacacionesService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _sessionHelper: SessionHelper) {
    this.selectedCompany = this._sessionHelper.LastCompanySelectedDiasVacaciones;
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.selectedYear = this._sessionHelper.LastYearSelectedDiasVacaciones, 0);
  }

  ngOnInit() {
    setTimeout(() => {
      if (this.selectedCompany) {
        this.onSearch();
      }
    }, 1000);
  }

  getHolidays(): void {
    this._vacacionesService.getAllByCompanyAndYear(this.selectedCompany, this.selectedYear).subscribe((response: Vacaciones[]) => {
      if (response) {
        this.holidays = response;
      }
    });
  }

  getPeriods(): void {
    this._vacacionesService.getPeriodsByCompanyAndYear(this.selectedCompany, this.selectedYear).subscribe((response: PeriodosVacacionesModel[]) => {
      if (response) {
        this.periodos = response;
      }
    });
  }

  onSearch(): void {
    this._sessionHelper.LastCompanySelectedDiasVacaciones = this.selectedCompany;
    this._sessionHelper.LastYearSelectedDiasVacaciones = this.selectedYear;
    this.getHolidays();
    this.getPeriods();
  }

  onClickEdit(row: Vacaciones): void {
    this._router.navigate([Configuration.editPath, row.Id], {
      relativeTo: this._activatedRoute,
      state: row
    });
  }

  onSelectedTabChange(): void {
    this.dataGrid.instance.repaint();
  }


  onEditorPreparing(e): void {
    if (e.parentType === 'searchPanel') {
      e.editorOptions.stylingMode = 'underlined';
    }
  }
}
